var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2, _rect, _rect2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect3, _path22, _polygon, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _polygon2, _polygon3, _polygon4, _polygon5, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _circle3, _path60, _rect4, _polygon6, _circle4, _circle5, _circle6, _path61, _path62, _path63, _path64, _path65, _path66, _polygon7, _polygon8, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _circle7, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _g, _rect5, _polygon9, _circle8, _circle9, _circle10, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConcept(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 1522.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2000,1702.34",
    transform: "translate(0 -219.64)",
    fill: "none",
    stroke: "#102048",
    strokeMiterlimit: 10,
    strokeWidth: 3.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,1737.34",
    transform: "translate(0 -219.64)",
    fill: "none",
    stroke: "#102048",
    strokeMiterlimit: 10,
    strokeWidth: 3.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M617.78,449.74c0,.15,0,.31-.07.46H247.79A62.83,62.83,0,0,1,339,394.09a62.92,62.92,0,0,1,72.68-42.7c29.35,5.75,50.13,32.14,50.13,62.06v.3c1,.15,2.72,1.51,3,.53,11-35,55.8-39.48,86.68-36.46C588.84,381.47,623.72,409,617.78,449.74Z",
    transform: "translate(0 -219.64)",
    fill: "#fff",
    stroke: "#8cbfbe",
    strokeMiterlimit: 10,
    strokeWidth: 3.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1752.6,1671.13c-28.85,0-52.25,18.35-52.25,41,0,9.55,4.17,18.35,11.17,25.32H1564.7a503.95,503.95,0,0,1,0-334.37H1711.6c-7-7-11.25-15.8-11.25-25.4,0-22.68,23.4-41,52.25-41s52.27,18.37,52.27,41c0,9.6-4.2,18.42-11.25,25.4h76.93v125.42c-6.85-6.6-15.4-10.5-24.65-10.5-22.65,0-41,23.4-41,52.25s18.38,52.28,41,52.28c9.25,0,17.8-3.9,24.65-10.5v125.42H1793.7c7-7,11.17-15.77,11.17-25.32C1804.87,1689.48,1781.47,1671.13,1752.6,1671.13Z",
    transform: "translate(0 -219.64)",
    fill: "#fbc343"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M389.83,851.48c0-349,282.88-631.84,631.84-631.84s631.84,282.88,631.84,631.84Z",
    transform: "translate(0 -219.64)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M389.83,851.48c0-349,282.88-631.84,631.84-631.84s631.84,282.88,631.84,631.84Z",
    transform: "translate(0 -219.64)",
    fill: "#fbc343",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M944.48,1740a58.14,58.14,0,0,1-58.05-56.54l-95.06-49.74H1252l-95.07,49.74a58.12,58.12,0,0,1-58,56.54Z",
    transform: "translate(0 -219.64)",
    fill: "#102048"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1241.8,1636.2l-87.38,45.72a55.55,55.55,0,0,1-55.56,55.56H944.48a55.56,55.56,0,0,1-55.57-55.56l-87.37-45.72H1241.8m20.34-5H781.2l18,9.43L884,1685a60.64,60.64,0,0,0,60.49,57.49h154.38a60.64,60.64,0,0,0,60.49-57.49l84.77-44.36,18-9.43Z",
    transform: "translate(0 -219.64)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1020.87,
    cy: 631.84,
    r: 501.55,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1020.87,
    cy: 631.84,
    r: 501.55,
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 801.54,
    y: 981.05,
    width: 440.26,
    height: 239.79,
    fill: "#fbc343"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 801.54,
    y: 1220.83,
    width: 440.26,
    height: 130.33,
    fill: "#708cd5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1348.35,617c-28.87,0-52.28,18.37-52.28,41,0,9.6,4.2,18.43,11.25,25.41H1188.85V569.8c-6.93,6.82-15.6,10.9-25,10.9-22.68,0-41-23.4-41-52.27s18.35-52.25,41-52.25c9.45,0,18.12,4.07,25,10.89V377.65a503,503,0,0,1,305.82,305.83H1389.35c7.05-7,11.25-15.81,11.25-25.41C1400.6,635.4,1377.2,617,1348.35,617Z",
    transform: "translate(0 -219.64)",
    fill: "#fbd682"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.85,1226c-6.93,6.83-15.6,10.9-25,10.9-22.68,0-41-23.4-41-52.25s18.35-52.27,41-52.27c9.45,0,18.12,4.07,25,10.9V1017.85h118.4c-7-7-11.18-15.77-11.18-25.33,0-22.67,23.41-41,52.28-41s52.25,18.35,52.25,41c0,9.56-4.18,18.36-11.18,25.33H1494.7a503,503,0,0,1-305.85,305.85Z",
    transform: "translate(0 -219.64)",
    fill: "#fbc343"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1348.35,951.5c-28.87,0-52.28,18.35-52.28,41,0,9.56,4.18,18.36,11.18,25.33h-118.4V889.53c7.27,8.32,16.88,13.4,27.45,13.4,22.65,0,41-23.4,41-52.25s-18.37-52.28-41-52.28c-10.57,0-20.18,5.08-27.45,13.4V683.48h118.47c-7-7-11.25-15.81-11.25-25.41,0-22.67,23.41-41,52.28-41s52.25,18.37,52.25,41c0,9.6-4.2,18.43-11.25,25.41h105.32a503.86,503.86,0,0,1,0,334.37H1389.42c7-7,11.18-15.77,11.18-25.33C1400.6,969.85,1377.2,951.5,1348.35,951.5Z",
    transform: "translate(0 -219.64)",
    fill: "#fbc343"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M854.5,1323.7v-97.3c-6.85,6.6-15.4,10.5-24.65,10.5-22.65,0-41-23.4-41-52.25s18.38-52.27,41-52.27c9.25,0,17.8,3.89,24.65,10.5v-125H980.57c-7-7-11.17-15.77-11.17-25.33,0-22.67,23.4-41,52.27-41s52.25,18.35,52.25,41c0,9.56-4.17,18.36-11.17,25.33h126.1v125.43c-6.93-6.83-15.6-10.9-25-10.9-22.68,0-41,23.4-41,52.27s18.35,52.25,41,52.25c9.45,0,18.12-4.07,25-10.9v97.7a504.06,504.06,0,0,1-334.35,0Z",
    transform: "translate(0 -219.64)",
    fill: "#fbc343"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1021.67,751c-28.87,0-52.27-18.37-52.27-41,0-10.12,4.67-19.4,12.42-26.52H854.5V570.2c-6.85,6.6-15.4,10.5-24.65,10.5-22.65,0-41-23.4-41-52.27s18.38-52.25,41-52.25c9.25,0,17.8,3.89,24.65,10.5v-109a504.06,504.06,0,0,1,334.35,0V487.07c-6.93-6.82-15.6-10.89-25-10.89-22.68,0-41,23.39-41,52.25s18.35,52.27,41,52.27c9.45,0,18.12-4.08,25-10.9V683.48H1061.5c7.75,7.12,12.42,16.4,12.42,26.52C1073.92,732.65,1050.52,751,1021.67,751Z",
    transform: "translate(0 -219.64)",
    fill: "#fbc343"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M736.55,617c-28.85,0-52.25,18.37-52.25,41,0,9.6,4.2,18.43,11.25,25.41H548.68A503,503,0,0,1,854.5,377.65v109c-6.85-6.61-15.4-10.5-24.65-10.5-22.65,0-41,23.39-41,52.25s18.38,52.27,41,52.27c9.25,0,17.8-3.9,24.65-10.5V683.48H777.57c7-7,11.25-15.81,11.25-25.41C788.82,635.4,765.43,617,736.55,617Z",
    transform: "translate(0 -219.64)",
    fill: "#fbd682"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1348.35,617c-28.87,0-52.28,18.37-52.28,41,0,9.6,4.2,18.43,11.25,25.41H1188.85V569.8c-6.93,6.82-15.6,10.9-25,10.9-22.68,0-41-23.4-41-52.27s18.35-52.25,41-52.25c9.45,0,18.12,4.07,25,10.89V377.65a503,503,0,0,1,305.82,305.83H1389.35c7.05-7,11.25-15.81,11.25-25.41C1400.6,635.4,1377.2,617,1348.35,617Z",
    transform: "translate(0 -219.64)",
    fill: "#fbc343"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1348.35,951.5c-28.87,0-52.28,18.35-52.28,41,0,9.56,4.18,18.36,11.18,25.33h-118.4V889.53c7.27,8.32,16.88,13.4,27.45,13.4,22.65,0,41-23.4,41-52.25s-18.37-52.28-41-52.28c-10.57,0-20.18,5.08-27.45,13.4V683.48h118.47c-7-7-11.25-15.81-11.25-25.41,0-22.67,23.41-41,52.28-41s52.25,18.37,52.25,41c0,9.6-4.2,18.43-11.25,25.41h105.32a503.86,503.86,0,0,1,0,334.37H1389.42c7-7,11.18-15.77,11.18-25.33C1400.6,969.85,1377.2,951.5,1348.35,951.5Z",
    transform: "translate(0 -219.64)",
    fill: "#fbc343"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1021.67,751c-28.87,0-52.27-18.37-52.27-41,0-10.12,4.67-19.4,12.42-26.52H854.5V570.2c-6.85,6.6-15.4,10.5-24.65,10.5-22.65,0-41-23.4-41-52.27s18.38-52.25,41-52.25c9.25,0,17.8,3.89,24.65,10.5v-109a504.06,504.06,0,0,1,334.35,0V487.07c-6.93-6.82-15.6-10.89-25-10.89-22.68,0-41,23.39-41,52.25s18.35,52.27,41,52.27c9.45,0,18.12-4.08,25-10.9V683.48H1061.5c7.75,7.12,12.42,16.4,12.42,26.52C1073.92,732.65,1050.52,751,1021.67,751Z",
    transform: "translate(0 -219.64)",
    fill: "#fbc343"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M736.55,617c-28.85,0-52.25,18.37-52.25,41,0,9.6,4.2,18.43,11.25,25.41H548.68A503,503,0,0,1,854.5,377.65v109c-6.85-6.61-15.4-10.5-24.65-10.5-22.65,0-41,23.39-41,52.25s18.38,52.27,41,52.27c9.25,0,17.8-3.9,24.65-10.5V683.48H777.57c7-7,11.25-15.81,11.25-25.41C788.82,635.4,765.43,617,736.55,617Z",
    transform: "translate(0 -219.64)",
    fill: "#fbc343"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1494.68,686H1383.27l4.32-4.28c6.88-6.8,10.51-15,10.51-23.63,0-21.25-22.32-38.54-49.75-38.54s-49.78,17.29-49.78,38.54c0,8.66,3.64,16.83,10.51,23.63l4.33,4.28H1186.35V575.29a36.7,36.7,0,0,1-22.55,7.91c-24,0-43.52-24.57-43.52-54.77s19.52-54.75,43.52-54.75a36.69,36.69,0,0,1,22.55,7.9V377.65h5v115.4l-4.26-4.19c-6.75-6.66-14.81-10.18-23.29-10.18-21.24,0-38.52,22.31-38.52,49.75s17.28,49.77,38.52,49.77c8.48,0,16.54-3.52,23.29-10.18l4.26-4.19V681h110.41a37.32,37.32,0,0,1-8.19-22.91c0-24,24.58-43.54,54.78-43.54s54.75,19.53,54.75,43.54a37.26,37.26,0,0,1-8.19,22.91h99.77Z",
    transform: "translate(0 -219.64)",
    fill: "#fdf6e6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.35,1323.7h-5v-92.21a36.7,36.7,0,0,1-22.55,7.91c-24,0-43.52-24.56-43.52-54.75s19.52-54.77,43.52-54.77a36.69,36.69,0,0,1,22.55,7.9V1015.35h115.36a37.31,37.31,0,0,1-8.14-22.83c0-24,24.58-43.52,54.78-43.52s54.75,19.53,54.75,43.52a37.31,37.31,0,0,1-8.14,22.83h99.74v5H1383.37l4.29-4.27c6.83-6.81,10.44-15,10.44-23.56,0-21.24-22.32-38.52-49.75-38.52s-49.78,17.28-49.78,38.52c0,8.61,3.62,16.75,10.45,23.56l4.28,4.27h-122v128.9l-4.26-4.2c-6.75-6.65-14.81-10.17-23.29-10.17-21.24,0-38.52,22.32-38.52,49.77s17.28,49.75,38.52,49.75c8.48,0,16.54-3.52,23.29-10.18l4.26-4.19Z",
    transform: "translate(0 -219.64)",
    fill: "#fdf6e6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M857,683.48h-5V575.61a36.65,36.65,0,0,1-22.15,7.59c-24,0-43.53-24.57-43.53-54.77s19.53-54.75,43.53-54.75A36.58,36.58,0,0,1,852,481.27V377.65h5V492.56l-4.24-4.08c-6.65-6.42-14.57-9.8-22.91-9.8-21.24,0-38.53,22.31-38.53,49.75s17.29,49.77,38.53,49.77c8.34,0,16.26-3.39,22.91-9.8l4.24-4.08Z",
    transform: "translate(0 -219.64)",
    fill: "#fdf6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 799.04,
    y: 1348.67,
    width: 445.26,
    height: 70.39,
    fill: "#102048"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1241.8,1570.81v65.39H801.54v-65.39H1241.8m5-5H796.54v75.39H1246.8v-75.39Z",
    transform: "translate(0 -219.64)",
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "932.31 864.31 831.04 864.31 831.04 856.81 924.81 856.81 924.81 754.11 932.31 754.11 932.31 864.31",
    fill: "#fdf6e6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M419.79,1729.79a502.94,502.94,0,0,1-290.63-320.34l146.65,7.13c-6.66-7.31-10.4-16.3-9.93-25.84,1.1-22.64,25.36-39.84,54.18-38.44s51.32,20.87,50.22,43.52c-.47,9.54-5.06,18.13-12.39,24.75l76.75,3.74-6.07,124.87c-6.52-6.92-14.87-11.23-24.11-11.68-22.62-1.1-42.11,21.38-43.51,50.22s15.81,53.08,38.44,54.18c9.23.45,18-3,25.13-9.29Z",
    transform: "translate(0 -219.64)",
    fill: "#fbc343"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M147.5,1521.3v216H594.29v-216Zm274.07,64.15a16.38,16.38,0,0,1-16.34,16.34H336.56a16.39,16.39,0,0,1-16.35-16.34h0a16.39,16.39,0,0,1,16.35-16.34h68.67a16.38,16.38,0,0,1,16.34,16.34Z",
    transform: "translate(0 -219.64)",
    fill: "#e5ecff",
    stroke: "#708cd5",
    strokeMiterlimit: 10,
    strokeWidth: 3.75
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M594.29,1737.34s-316.08-22.24-446.79-216v216Z",
    transform: "translate(0 -219.64)",
    fill: "#1f3c88",
    opacity: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1728.43,376.55a60.56,60.56,0,0,1-.7,9.29H1357.81a62.85,62.85,0,0,1,91.2-56.11,62.85,62.85,0,0,1,59.94-44c34.72,0,56.93,15.31,56.93,50v.74a62.36,62.36,0,0,1,32,15c5.67-28.92,37.21-40.79,67.63-37.9C1705.83,317.5,1728.43,341.83,1728.43,376.55Z",
    transform: "translate(0 -219.64)",
    fill: "#fff",
    stroke: "#8cbfbe",
    strokeMiterlimit: 10,
    strokeWidth: 3.75
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1373.83,1108c3.59-9.85-1.59-15.74-1.74-21.08s1.48-10.09-1.41-10.79-6.3,3.7-8.18,26.92Z",
    transform: "translate(0 -219.64)",
    fill: "#f9b384"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1377,1117.34l-3.75,15.13H1349.7l-14.39-32.16c-2.07-3.87-7.69-19.45-7.19-22.73.94-6.12,8.4,9,8.76,9.3-1.33-4.6-5.84-19.08-3.76-22.35,2.5-3.91,10.09,13,12,18.12-1-4.73-6.46-22.57-3.79-25.16,3.21-3.11,10.66,16.6,11.81,22.77-.3-4.62-2.53-20.43.57-20,4.27.52,11.73,28.24,11.73,28.24A94.38,94.38,0,0,1,1377,1117.34Z",
    transform: "translate(0 -219.64)",
    fill: "#f9b384"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1340.16,1096.21a37.35,37.35,0,0,1,9-6.33,20.86,20.86,0,0,1,5.31-1.71,13.74,13.74,0,0,1,5.57.18l-.08.48a20.35,20.35,0,0,0-10.28,2.17,69.12,69.12,0,0,0-9.22,5.6Z",
    transform: "translate(0 -219.64)",
    fill: "#e28b6d"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1362.49,1094.38a4,4,0,0,0-3.67,2,8.63,8.63,0,0,0-.62,4.43,21.79,21.79,0,0,0,.86,4.64,20.79,20.79,0,0,0,1.75,4.41l-.39.3a14.37,14.37,0,0,1-2.4-4.37,18.9,18.9,0,0,1-1.06-4.89,8.91,8.91,0,0,1,1-5,6.14,6.14,0,0,1,.87-1.05,6.91,6.91,0,0,1,1.17-.69,8.46,8.46,0,0,1,1.29-.27l1.28,0Z",
    transform: "translate(0 -219.64)",
    fill: "#e28b6d"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1461.07,1709.57l2.26-29h-39.11l-5.42,12.25a52.1,52.1,0,0,1-9.14,14C1421.25,1712.82,1439.31,1719.48,1461.07,1709.57Z",
    transform: "translate(0 -219.64)",
    fill: "#f9b384"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1409.66,1706.72a52.08,52.08,0,0,1-19.92,13.66l-17.48,6.69a5.57,5.57,0,0,0,3,10.27H1446a13.89,13.89,0,0,0,13.86-12.82l1.17-15C1439.31,1719.48,1421.25,1712.82,1409.66,1706.72Z",
    transform: "translate(0 -219.64)",
    fill: "#102048"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1556.86,1709.57l-2.27-29h39.11l5.42,12.25a52.1,52.1,0,0,0,9.14,14C1596.67,1712.82,1578.61,1719.48,1556.86,1709.57Z",
    transform: "translate(0 -219.64)",
    fill: "#f9b384"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1608.26,1706.72a52.16,52.16,0,0,0,19.92,13.66l17.49,6.69a5.57,5.57,0,0,1-3,10.27h-70.79a13.91,13.91,0,0,1-13.87-12.82l-1.16-15C1578.61,1719.48,1596.67,1712.82,1608.26,1706.72Z",
    transform: "translate(0 -219.64)",
    fill: "#102048"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1603.52,1686.1h-67.29L1499.67,1403l-19,128.63-3.94,154.43h-63.21c-5-119.86,1.32-248.68,22-389l1.39-22.29,1.6-25.43,127.13,9.33,1.52,17.32,2.95,33Z",
    transform: "translate(0 -219.64)",
    fill: "#1f3c88"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1570.12,1309.1c-12,18.09-95.43,17.46-135-4.68l1.85-29.59,130.25,1.22Z",
    transform: "translate(0 -219.64)",
    fill: "#102048",
    opacity: 0.6
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1432,1256.85s-12.58,32.57-1.78,38.82,135.36,7.5,145.22,0-14-26.25-11.73-38.75S1432,1256.85,1432,1256.85Z",
    transform: "translate(0 -219.64)",
    fill: "#708cd5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.34,1123c-4.38,9.68-20.63,39.06-20.63,39.06L1377,1117.34c-5.31,4.31-11.57,8.33-30.18,8.59,0,0,26.75,98.91,50.81,109.08,39.46,16.69,48.75-58,48.75-58Z",
    transform: "translate(0 -219.64)",
    fill: "#708cd5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1421.34,1123l6.43-15.09a26.37,26.37,0,0,1,13-13.83c.56-.26,1.14-.5,1.73-.72,11.17-4.23,31.87-10.89,51.08-10.68,6.87,0,32.45-.3,74,10.32l11.6,148.43-137.5-2.81Z",
    transform: "translate(0 -219.64)",
    fill: "#708cd5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1544.06,1123c3.23,55.78-1.27,115.73-33.75,119.6l37.52,10.55,40.29-21.56-15.93-87.81Z",
    transform: "translate(0 -219.64)",
    fill: "#1f3c88",
    opacity: 0.3
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1550.15,1088.94c8.29,1.82,22.13,3.71,29,8.4s26.25,105,31.25,128.13,6.25,46.87-96.25,50.62l-10-28.12,60-23.13-23-101.87Z",
    transform: "translate(0 -219.64)",
    fill: "#708cd5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1439.66,1130.62c.72,10,1,20.09,1.38,30.14l.31,15.08c0,5,.06,10.05,0,15.09l-.73,0c-.38-5-.63-10-.86-15.07l-.52-15.07c-.22-10.06-.43-20.11-.26-30.18Z",
    transform: "translate(0 -219.64)",
    fill: "#1f3c88"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "1553.99 1014.58 1553.99 1020.36 1525.38 1046.22 1523.13 1035.56 1553.99 1014.58",
    fill: "#102048"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "1521.21 1042.47 1553.99 1014.58 1492.28 1006.87 1521.21 1042.47",
    fill: "#fff"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "1525.38 1046.22 1406.71 1046.22 1386.84 951.77 1505.51 951.77 1525.38 1046.22",
    fill: "#102048"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "1462.74 1005.63 1449.47 1005.63 1446.97 992.36 1460.24 992.36 1462.74 1005.63",
    fill: "#fff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1452.06,986.28c-13.31-33.78,42.32-46.28,47.74-18,0,0,15.89-8.25,31.67.5,30.41,16.85,10.77,64.34,0,64.34l-54.92-7.17Z",
    transform: "translate(0 -219.64)",
    fill: "#6f3428"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1521.6,1050.3v34.58c0,9.5-9.1,17.21-20.37,17.21s-20.36-7.71-20.36-17.21V1050.3Z",
    transform: "translate(0 -219.64)",
    fill: "#f9b384"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1512.83,1063.27c-5.23,6.93-16.45,14.9-32,15.08v-18.23Z",
    transform: "translate(0 -219.64)",
    fill: "#3c1c16"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1521.6,994.4v59.2s-11.62,19.75-35.4,18.13c-11.8-.83-17.75-8.21-20.85-20a93.47,93.47,0,0,1-2.55-15.28c-.9-9.47-1.15-20.44-1.47-32.3V994.4Z",
    transform: "translate(0 -219.64)",
    fill: "#f9b384"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1461.81,980c-7.34-6.4-22.2-1.53-26.57,7.47-6.17,12.71,1.87,25.55,12.3,29.06,15.12,5.1,21.26-10.81,21.26-10.81s4.89,6.9,15.77,5.4c7.84-1.08,10.55-8.78,10.55-8.78s2.42,19.67,28.24,19.19c5.55-1.89,8.11-23.38,8.11-23.38l-17-17.71Z",
    transform: "translate(0 -219.64)",
    fill: "#6f3428"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1514.15,1276.09c-12.68,2.6-26,4.14-38.88,2.16-8-1.22-15.89-4-22.37-9a46,46,0,0,1-12.88-16.06c-.71-1.47-1.2-3.64,0-5s3.76,1,5,2a55.1,55.1,0,0,1,10.94,11.67s-9.73-16-7.29-18.55c1.87-2,4.71-1.49,14.5,14.76,0,0,1.85,4,3.62,1.91,1-1.12-5.59-13.7-.83-14.79,3.64-.83,7.08,11,9.58,15.73,3.13,3.64,8.54,0,8.54,0l26.4,5Z",
    transform: "translate(0 -219.64)",
    fill: "#f9b384"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1483.47,1261.73a36.82,36.82,0,0,0-2.16-7.88,8.85,8.85,0,0,1-.59-1.78c-.39-2.31,1.67-3,3-2.53,3,1,5.73,5.08,7.51,8.22a15.62,15.62,0,0,1,2,9.56c-.14,1-8.67,1-9.22-.2a2.83,2.83,0,0,1-.17-1A40.85,40.85,0,0,0,1483.47,1261.73Z",
    transform: "translate(0 -219.64)",
    fill: "#f9b384"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1493.91,1355.77c1.6,10.28,3.15,20.57,4.59,30.87l4.22,30.91,3.88,31,1.8,15.5,1.64,15.52-1,.13-2.4-15.42-2.23-15.44-4.18-30.93-3.85-31q-1.87-15.5-3.47-31Z",
    transform: "translate(0 -219.64)",
    fill: "#708cd5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1477.76,1109.78a33.07,33.07,0,0,0,24.13,8.75,31.28,31.28,0,0,0,12.55-3.46,44.46,44.46,0,0,0,10.67-7.82l.54.5a37.64,37.64,0,0,1-10.45,8.77,30.72,30.72,0,0,1-26.77,1.57,30.48,30.48,0,0,1-11.19-7.79Z",
    transform: "translate(0 -219.64)",
    fill: "#1f3c88"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1518.73,1024.52c2.69-6.68,7.9-8.53,13-6.17,8,3.76,5.37,24.58-13,25Z",
    transform: "translate(0 -219.64)",
    fill: "#f9b384"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1522.76,1028.28a6.66,6.66,0,0,1,1.64-5.65,4,4,0,0,1,3.08-1.28,4.13,4.13,0,0,1,2.74,1.48l-.44.59a5.1,5.1,0,0,0-2.3-.43,2.78,2.78,0,0,0-1.75.94,7.09,7.09,0,0,0-1.34,2,14,14,0,0,0-.9,2.4Z",
    transform: "translate(0 -219.64)",
    fill: "#6f3428"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1475.52,1028c0,2.34-1.29,4.23-2.89,4.23s-2.89-1.89-2.89-4.23,1.29-4.23,2.89-4.23S1475.52,1025.64,1475.52,1028Z",
    transform: "translate(0 -219.64)",
    fill: "#3c1c16"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1500,1028c0,2.34-1.3,4.23-2.9,4.23s-2.89-1.89-2.89-4.23,1.3-4.23,2.89-4.23S1500,1025.64,1500,1028Z",
    transform: "translate(0 -219.64)",
    fill: "#3c1c16"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1483.77,1029.62a14.48,14.48,0,0,1,.62,2.68,12.63,12.63,0,0,1,.11,1.38,3.14,3.14,0,0,1-.26,1.67c-.72,1.24-1.87,1.43-2.49,1.82a3.23,3.23,0,0,0-1.4,1.5,3.11,3.11,0,0,0,.77,3.74c1.05.95,2.83,1.09,4.53.94l.17.72a6.2,6.2,0,0,1-5.7-.36,4.74,4.74,0,0,1-1.44-5.86,5,5,0,0,1,2.27-2.24,2.39,2.39,0,0,0,2.17-3.24,25.14,25.14,0,0,0-.06-2.6Z",
    transform: "translate(0 -219.64)",
    fill: "#e28b6d"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1477.15,1053a19.24,19.24,0,0,0,4.53.82,22.68,22.68,0,0,0,4.59-.09,17,17,0,0,0,4.4-1,19.1,19.1,0,0,0,4.08-2.12l.5.53a11.94,11.94,0,0,1-3.93,3.1,14.92,14.92,0,0,1-4.84,1.38,18.19,18.19,0,0,1-5-.18,12.26,12.26,0,0,1-4.67-1.74Z",
    transform: "translate(0 -219.64)",
    fill: "#3c1c16"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1465.74,1021.81a9.7,9.7,0,0,1,2.63-3,6.29,6.29,0,0,1,4-1.25,8.76,8.76,0,0,1,3.91,1.29,14.12,14.12,0,0,1,3,2.57l-.32.36a30.44,30.44,0,0,0-3.23-2,8.61,8.61,0,0,0-3.43-1c-2.37-.19-4.45,1.45-6.16,3.32Z",
    transform: "translate(0 -219.64)",
    fill: "#3c1c16"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1490.28,1021.81a8.45,8.45,0,0,1,3.18-3.07,8.33,8.33,0,0,1,4.41-1,11.71,11.71,0,0,1,7.71,4l-.33.37c-2.31-1.59-4.77-3-7.45-3.14a8.75,8.75,0,0,0-7.12,3.1Z",
    transform: "translate(0 -219.64)",
    fill: "#3c1c16"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1505.74,
    cy: 823.15,
    r: 7.79,
    fill: "#ee6f57",
    opacity: 0.4
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1472.52,1044a7.74,7.74,0,0,1-7.17,7.73,93.47,93.47,0,0,1-2.55-15.28,7.19,7.19,0,0,1,1.93-.25A7.81,7.81,0,0,1,1472.52,1044Z",
    transform: "translate(0 -219.64)",
    fill: "#ee6f57",
    opacity: 0.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1610.74,
    y: 684.06,
    width: 191.11,
    height: 105.5,
    rx: 45.56,
    fill: "#c6eae9"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "1639.8 750.49 1593.7 789.56 1685.91 789.56 1639.8 750.49",
    fill: "#c6eae9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1671.92,
    cy: 736.81,
    r: 9.83,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1706.3,
    cy: 736.81,
    r: 9.83,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1740.67,
    cy: 736.81,
    r: 9.83,
    fill: "#fff"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M461.18,1148c-5,6.26-20.92,59.45-20.92,59.45s16.67,10.44,42.36,7.67C481.67,1215.11,461.18,1148,461.18,1148Z",
    transform: "translate(0 -219.64)",
    fill: "#ee6f57"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M512,1713.51l2-25.08H480.19L475.52,1699a45.15,45.15,0,0,1-7.89,12C477.64,1716.31,493.22,1722.06,512,1713.51Z",
    transform: "translate(0 -219.64)",
    fill: "#f9b384"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M467.63,1711.05a45,45,0,0,1-17.2,11.79l-15.09,5.78a4.8,4.8,0,0,0,2.57,8.86H499a12,12,0,0,0,12-11.07l1-12.9C493.22,1722.06,477.64,1716.31,467.63,1711.05Z",
    transform: "translate(0 -219.64)",
    fill: "#102048"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M612.17,1713.51l-2-25.08H644l4.67,10.57a45.15,45.15,0,0,0,7.89,12C646.53,1716.31,631,1722.06,612.17,1713.51Z",
    transform: "translate(0 -219.64)",
    fill: "#f9b384"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M656.54,1711.05a45,45,0,0,0,17.2,11.79l15.09,5.78a4.8,4.8,0,0,1-2.57,8.86H625.14a12,12,0,0,1-12-11.07l-1-12.9C631,1722.06,646.53,1716.31,656.54,1711.05Z",
    transform: "translate(0 -219.64)",
    fill: "#102048"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M658.6,1698.22H590.2l-49.72-298.65-15.56,298.65H462.4l3.7-306.6c-6.37-28.52-4.3-50.54,4.58-73.64a186.28,186.28,0,0,1,8-18c2.07-4.1,4.33-8.33,6.78-12.65h109.4l1.94,12.65,1.1,7Z",
    transform: "translate(0 -219.64)",
    fill: "#708cd5"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "594.53 874.22 562.16 914.78 597.93 930.33 621.51 882.43 610.99 872.84 594.53 874.22",
    fill: "#f9b384"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "543.15 921.17 506.01 921.17 508.51 870.65 545.65 870.65 543.15 921.17",
    fill: "#f9b384"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M561.39,1050.51c8.05,10.38,12.41,15.7,12,18s-3.28,7.23-13.24,5.59C560.57,1072.35,561.39,1050.51,561.39,1050.51Z",
    transform: "translate(0 -219.64)",
    fill: "#e28b6d"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M563.5,1080.19c-1.38,8.71-5.21,15-13.76,15.86-21.83,2.19-42.58-6.92-42.58-6.92l-4-47.67,19.29-13.83,38.94,5.83c.41,8.6,2,19.23,2.56,29.28A82.83,82.83,0,0,1,563.5,1080.19Z",
    transform: "translate(0 -219.64)",
    fill: "#f9b384"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M545.56,1039.82c9.46,8.92,20.83,9.66,27.86,3.64,14.9-12.73,5.15-43.48-27.86-32,0,0-36.4-16.56-57.5,5.28S483,1062,456.91,1096.39c0,0,49.83,32.9,108.42,1.76-9.36-16.78-27.8-3.52-28.33-31.71C536.82,1066,534.09,1042.55,545.56,1039.82Z",
    transform: "translate(0 -219.64)",
    fill: "#102048"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M602.5,1300c-.4,2.25-2,4.6-4.58,7-16.59,15.13-74.6,29.93-127.24,11a186.28,186.28,0,0,1,8-18Z",
    transform: "translate(0 -219.64)",
    fill: "#1f3c88",
    opacity: 0.3
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M598,1307.5c-7.65,3.37-88.1,20.42-126.32-1.68-2.91-2.52-10.43-4.9.2-18.47s-6.13-85.95-10.71-139.35a104.92,104.92,0,0,1,51-26.75c15.17-3,31.52-1.7,44.85,0s35.4,10.63,35.4,10.63l-1.7,60.72s-.52,2.88-1.18,7.65c0,0,0,0,0,0a287.12,287.12,0,0,0-2.77,36.55c-.13,17.4,2,35.45,9.82,44.75C610.2,1297.83,605.62,1304.1,598,1307.5Z",
    transform: "translate(0 -219.64)",
    fill: "#ee6f57"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M632.45,1169.7l-9.22,51.83a.45.45,0,0,1-.18-.1l-11.59-7.32-.33-.22a5.63,5.63,0,0,0-.54-.36l-44.85-28.29-18.9-65.1c18.47,2.75,38.68,4.13,51.32,15.57C607.28,1144,622.18,1159.2,632.45,1169.7Z",
    transform: "translate(0 -219.64)",
    fill: "#ee6f57"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M690.93,1104.34s-14.66,98.66-17.2,108.53c-.36,1.36-.75,2.71-1.25,4.08-3.08,8.67-9.23,17.15-21.36,16.3a33.89,33.89,0,0,1-9.47-2.45,130.35,130.35,0,0,1-18.43-9.28l9.23-51.82c3.95,4,7.23,7.35,9.23,9.3l16-79.44Z",
    transform: "translate(0 -219.64)",
    fill: "#f9b384"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M757.43,1010.1c-28.87,0-52.27,18.35-52.27,41,0,9.55,4.17,18.35,11.17,25.32H590.26V951c-6.85,6.6-15.4,10.5-24.65,10.5-22.65,0-41-23.4-41-52.28S543,857,565.61,857c9.25,0,17.8,3.9,24.65,10.5V742.08H717.58c-7.75,7.12-12.42,16.4-12.42,26.52,0,22.65,23.4,41,52.27,41s52.25-18.38,52.25-41c0-10.12-4.67-19.4-12.42-26.52H924.61V870.4c7.27-8.32,16.87-13.4,27.45-13.4,22.65,0,41,23.4,41,52.28s-18.37,52.25-41,52.25c-10.58,0-20.18-5.08-27.45-13.4v128.32H798.51c7-7,11.17-15.77,11.17-25.32C809.68,1028.45,786.28,1010.1,757.43,1010.1Z",
    transform: "translate(0 -219.64)",
    fill: "#fbc343"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M657.71,1107.07c-1.52-9.84.41-20.4,2.6-32.37l34.08.32c-4.43,10.3,3.73,20.6-3.46,29.32l-15.75,16.88Z",
    transform: "translate(0 -219.64)",
    fill: "#f9b384"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M621.51,1102.07c8.41-5.68,17.78-26.89,17.78-26.89-6.52-.33-30.15-.88-39.3,0,0,0,.06,12.73-5.46,18.68C591.24,1097.4,621.51,1102.07,621.51,1102.07Z",
    transform: "translate(0 -219.64)",
    fill: "#f9b384"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M542.47,1065.15c-.88-5.08-3.85-8-8.8-9.48-3.24-1-7.71.58-8.86,4.26-2,6.55,1.09,23.06,16.11,15.69C542.6,1074.89,543.55,1071.48,542.47,1065.15Z",
    transform: "translate(0 -219.64)",
    fill: "#f9b384"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M472.48,1237.61c-1-6.12-2-12.25-2.93-18.38l-2.65-18.42-2.41-18.45c-.75-6.16-1.45-12.32-2.06-18.5l.72-.1q1.59,9.18,3,18.38l2.63,18.42,2.38,18.46q1.14,9.23,2.09,18.49Z",
    transform: "translate(0 -219.64)",
    fill: "#6f3428"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M589.5,1200.25a287.12,287.12,0,0,0-2.77,36.55c-11-19.8-15.8-48.28-15.8-48.28S580.23,1194.38,589.5,1200.25Z",
    transform: "translate(0 -219.64)",
    fill: "#6f3428",
    opacity: 0.3
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M592.38,1132.23a20.31,20.31,0,0,0-6.19,1.27,21,21,0,0,0-5.39,3.18,31.83,31.83,0,0,0-4.49,4.5,47.94,47.94,0,0,0-3.79,5.22l-.67-.3a24.42,24.42,0,0,1,3.16-5.92,26.78,26.78,0,0,1,4.63-5,19.62,19.62,0,0,1,6-3.23,15.52,15.52,0,0,1,6.76-.5Z",
    transform: "translate(0 -219.64)",
    fill: "#6f3428"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M521.35,1397.56a71.9,71.9,0,0,0,9.75,1.36,73.14,73.14,0,0,0,9.82,0,92.22,92.22,0,0,0,9.78-1.07c3.24-.5,6.48-1.16,9.67-2l.25.7a57,57,0,0,1-9.63,2.87,69.4,69.4,0,0,1-10,1.31,58.43,58.43,0,0,1-10.07-.29,45.63,45.63,0,0,1-9.8-2.22Z",
    transform: "translate(0 -219.64)",
    fill: "#1f3c88"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M563.5,1080.19a7.48,7.48,0,0,1-1.66.16,8.95,8.95,0,0,1,0-17.89,7.71,7.71,0,0,1,2.1.28A82.83,82.83,0,0,1,563.5,1080.19Z",
    transform: "translate(0 -219.64)",
    fill: "#ee6f57",
    opacity: 0.4
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M534.42,1064c-.83-1.3-1.78-2.64-2.83-2.92a2.08,2.08,0,0,0-1.6.31,14.33,14.33,0,0,0-1.82,1.31l-.55-.39a5.35,5.35,0,0,1,1.51-2.16,3.29,3.29,0,0,1,2.94-.71,4.15,4.15,0,0,1,2.21,1.87,5.63,5.63,0,0,1,.78,2.49Z",
    transform: "translate(0 -219.64)",
    fill: "#6f3428"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 479.76,
    cy: 1018.14,
    r: 15.66,
    transform: "translate(-602.08 1108.98) rotate(-80.78)",
    fill: "#102048"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M672.48,1217c-3.08,8.67-9.23,17.15-21.36,16.3a33.89,33.89,0,0,1-9.47-2.45C646.63,1217.33,657.07,1213.62,672.48,1217Z",
    transform: "translate(0 -219.64)",
    fill: "#ee6f57",
    opacity: 0.4
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M696.15,1069.47c-.25,1.28-1,2.65-1.33,4.35-2.48,12.85-3.3,14.78-3.3,14.78l-9.79-5c1.92-6.72,6.8-16.26,9.4-19.49,1.4-1.75,2.32-2.86,3.85-1.44C696.15,1063.73,696.82,1065.92,696.15,1069.47Z",
    transform: "translate(0 -219.64)",
    fill: "#f9b384"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M696.15,1069.47c-4.08-1.12-2-3-1.17-6.8C696.15,1063.73,696.82,1065.92,696.15,1069.47Z",
    transform: "translate(0 -219.64)",
    fill: "#e28b6d"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M606.27,1062.82c-.2,1.28,0,2.82-.23,4.54-2,12.92-1.91,15-1.91,15L615,1081c.48-7-.88-17.61-2.23-21.52-.72-2.12-1.21-3.48-3.13-2.66C608.22,1057.41,606.84,1059.25,606.27,1062.82Z",
    transform: "translate(0 -219.64)",
    fill: "#f9b384"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M606.27,1062.82c4.22.32,2.91-2.17,3.41-6C608.22,1057.41,606.84,1059.25,606.27,1062.82Z",
    transform: "translate(0 -219.64)",
    fill: "#e28b6d"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M615.18,1073a4.32,4.32,0,0,0,1.1,2.89c.67.75,1.82,1.36,2.44,2.69a5.61,5.61,0,0,1-.06,3.8,9.81,9.81,0,0,1-1.72,3.16l-.41-.26a17.13,17.13,0,0,0,1.08-3.19,5,5,0,0,0,0-3c-.3-.88-1.33-1.47-2.12-2.51a4.43,4.43,0,0,1-.77-3.62Z",
    transform: "translate(0 -219.64)",
    fill: "#e28b6d"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M685.56,1074.46a7.21,7.21,0,0,1-2.43,4.2c-1.31,1.15-2.94,1.45-3.67,2.59a7.52,7.52,0,0,0-1.3,4,12.51,12.51,0,0,0,.51,4.45l-.45.19a9.91,9.91,0,0,1-1.15-4.68,8,8,0,0,1,1.41-4.76c1.16-1.5,2.93-1.8,4-2.66a7.65,7.65,0,0,0,2.61-3.5Z",
    transform: "translate(0 -219.64)",
    fill: "#e28b6d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.29,1287.1c2.12,2.62,5.23,4.3,8.35,5.72a70.19,70.19,0,0,0,9.83,3.44,89.53,89.53,0,0,0,10.21,2.28,61.63,61.63,0,0,0,10.4,1l.11,1a38.71,38.71,0,0,1-10.8.21,65.83,65.83,0,0,1-10.59-2.06,55.22,55.22,0,0,1-10.08-3.92c-3.16-1.7-6.4-3.79-8.26-7.12Z",
    transform: "translate(0 -219.64)",
    fill: "#6f3428"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 196.35,
    y: 991.22,
    width: 191.11,
    height: 105.5,
    rx: 45.56,
    transform: "translate(583.8 1868.29) rotate(180)",
    fill: "#d3dfff"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "358.39 838.01 404.5 877.08 312.29 877.08 358.39 838.01",
    fill: "#d3dfff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 326.27,
    cy: 1043.97,
    r: 9.83,
    transform: "translate(-231.13 -116.75) rotate(-13.28)",
    fill: "#fff"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.9,
    cy: 1043.97,
    r: 9.83,
    transform: "translate(-232.04 -124.65) rotate(-13.28)",
    fill: "#fff"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.53,
    cy: 1043.97,
    r: 9.83,
    transform: "translate(-232.96 -132.54) rotate(-13.28)",
    fill: "#fff"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 1517.7,
    x2: 2000,
    y2: 1517.7,
    fill: "none",
    stroke: "#102048",
    strokeMiterlimit: 10,
    strokeWidth: 3.75
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcept);
export default __webpack_public_path__ + "static/media/Concept.041b5bce60ebe309cdf6fc8d977a3d98.svg";
export { ForwardRef as ReactComponent };